export default "__VITE_ASSET__Dp$W5XtA__"